import { getConfig } from "libs/api/configs";
import { TranslationKey } from "libs/locale/i18nLanguages";
import { useQuery } from "react-query";
import { useSetRecoilState } from "recoil";
import { coldStartContextState } from "states/app";

const createKey = () => ["config"];

export default function useConfigQuery() {
  useSetRecoilState(coldStartContextState)(
    TranslationKey["앱 설정 조회 중..."]
  );

  const { data } = useQuery(createKey(), getConfig);

  if (data === undefined) {
    throw new Error("config 값이 존재하지 않습니다.");
  }

  return data;
}
